import React from 'react';
import Pricing from '../../Pricing';
import SectionHeading from '../../SectionHeading';
import Spacing from '../../Spacing';

export default function PricingSection({ sectionTitle, data, headerColor, titleBgColor, onSubscribeClick }) {
  return (
    <div className="container">
      <SectionHeading 
        title={sectionTitle} 
        center 
        data-aos="fade-up"
        data-aos-delay="100"
      />
      <Spacing md="72" lg="50" />
      <div className="row cs_gap_y_50">
        {data?.map((item, index) => (
          <div 
            className="col-xl-4" 
            key={index}
            data-aos="fade-up"
            data-aos-delay={`${(index + 1) * 300}`}
          >
            <Pricing {...item} headerColor={headerColor} titleBgColor={titleBgColor} onSubscribeClick={onSubscribeClick} />
          </div>
        ))}
      </div>
    </div>
  );
}
